import { module } from 'modujs';
import { createElementFromHTML } from '../utils/html'

export default class extends module {
    constructor(m) {
        super(m);

        this.events = {
            click: {
                addBtn:    'addItem',
                removeBtn: 'removeItem',
            },
        };
    }

    get max() {
        return parseInt(this.el.getAttribute('data-list-max')) || null;
    }

    get min() {
        return parseInt(this.el.getAttribute('data-list-min')) || null;
    }

    init() {
        // Get list container
        this.list = this.$('list')[0];

        this.setTemplate();

        if (this.min) {
            for (var i = 0; i < this.min; i++) {
                this.addItem(); // Append the first item(s) of the list
            }
        }
    }

    setTemplate() {
        const templateEl = this.$('template')[0];
        this.template = templateEl.innerHTML;
        templateEl.remove();
    }

    addItem() {
        if (this.max && this.$('item').length >= this.max) {
            return;
        }

        const item = createElementFromHTML(this.template);
        this.list.appendChild(item);
        this.updateList();

        this.el.dispatchEvent(new CustomEvent('addedItem', {
            bubbles: true,
            detail:  { item },
        }));

        if (this.max && this.$('item').length >= this.max) {
            this.$('addBtn').forEach((button) => button.setAttribute('aria-disabled', 'true'));
        }
    }

    removeItem(event) {
        if (event.curTarget?.getAttribute('aria-disabled') === 'true') {
            return;
        }

        const item = this.parent('item', event.curTarget);
        this.call('destroy', item, 'app');
        item.remove();
        this.updateList();

        this.el.dispatchEvent(new CustomEvent('removedItem', {
            bubbles: true,
            detail:  { item },
        }));

        if (this.max && (this.$('item').length - 1) < this.max) {
            this.$('addBtn').forEach((button) => button.setAttribute('aria-disabled', 'false'));
        }
    }

    updateList() {
        this.call('destroy', this.list, 'app');

        this.$('item').forEach((item, i) => {
            this.updateItemId(item, i);

            if (this.min && (this.min > i)) {
                const removeBtn = item.querySelector('[data-duplicate-field="removeBtn"]');
                if (removeBtn) {
                    removeBtn.remove();
                }
            }
        });

        this.call('update', this.list, 'app');
    }

    updateItemId(item, index) {
        const iteration = (index + 1);

        item.id = item.id.replace('{%index%}', index);

        item.querySelectorAll('[id],[for],[name],[data-swap-departure],[data-swap-arrival]').forEach((el) => {
            if (el.id) {
                el.id = el.id.replace('{%index%}', index);
            }

            if (el.htmlFor) {
                el.htmlFor = el.htmlFor.replace('{%index%}', index);
            }

            if (el.name) {
                el.name = el.name.replace('{%index%}', index);
            }

            if (el.dataset.swapDeparture) {
                el.dataset.swapDeparture = el.dataset.swapDeparture.replace('{%index%}', index);
            }

            if (el.dataset.swapArrival) {
                el.dataset.swapArrival = el.dataset.swapArrival.replace('{%index%}', index);
            }
        });

        this.$('index', item).forEach((el) => el.innerText = index);
        this.$('iteration', item).forEach((el) => el.innerText = iteration);
    }
}
